<template>
  <div class="cart">
    <div class="header">
      <router-link to="/index" class="fl back-btn"></router-link>
      <a @click="clearCart" class="fr icon icon-delete"><span></span></a>
      <h2>购物车</h2>
    </div>
    <div class="main">
      <div class="no-goods" v-if="cartInfo.total == 0">
        您的购物车为空
      </div>
      <div class="list" v-else>
        <ul>
          <li v-for="item in cartInfo.market">
            <div class="media-box">
              <div class="media-img fl">
                <a class="gd picw"><img :src="item.title_image_path"></a>
              </div>
              <div class="media-content">
                <h2>{{item.title}}</h2>
                <div class="price fl">
                  <span>{{item.wx_price}}</span>
                </div>
                <div class="num-box fr">
                  <span class="btns minusBtn icon-removecart" @click="minusGoods($event)" :id="item.goods_id"></span>
                  <span class="box">{{item.num}}</span>
                  <span class="btns addBtn icon-addtocart" @click="addGoods($event)" :id="item.goods_id"></span>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="settle-box">
              <div class="footer-cart fl">合计：
                <span class="price">
                  <span class="amounts">{{cartInfo.amount}}</span>
                </span>
              </div>
              <a @click="settleAccount" class="btn btn-red btn-lg fr" data-name="market">结算</a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import BackBtn from '../components/BackBtn.vue'

  export default {
    name: 'cart',
    data () {
      return {
      }
    },
    computed: {
      cartInfo () {
        return this.$store.state.cartInfo
      },
      wxUid () {
        return this.$store.state.wxUid
      }
    },
    mounted () {
      var _this = this
      _this.getTotalPrice()
    },
    methods: {
      // 计算总价
      getTotalPrice: function () {
        var _this = this
        var totalPrice = 0;
        for(var key in _this.cartInfo.market) {
          var singlePrice = _this.cartInfo.market[key].wx_price
          var singleNum = _this.cartInfo.market[key].num
          var singleTotalPrice = singlePrice * singleNum
          totalPrice += parseFloat(singleTotalPrice)
        }
        _this.cartInfo.amount = totalPrice.toFixed(2)
      },
      // 增加商品
      addGoods: function (e) {
        var _this = this
        for(var key in _this.cartInfo.market) {
          if(e.target.id == _this.cartInfo.market[key].goods_id) {
            _this.cartInfo.market[key].num += 1
          }
        }
        _this.cartInfo.total += 1
        _this.getTotalPrice()
        _this.$store.commit('changeCartInfo', _this.cartInfo)
      },
      // 删减商品
      minusGoods: function (e) {
        var _this = this
        var cartInfo = _this.cartInfo
        for(var key in _this.cartInfo.market) {
          if(e.target.id == _this.cartInfo.market[key].goods_id) {
            if(_this.cartInfo.market[key].num == 1) {
              delete _this.cartInfo.market[key]
              var obj = {}
              for(var m in _this.cartInfo.market) {
                obj[m] = _this.cartInfo.market[m]
              }
              cartInfo.market = obj
            } else {
              _this.cartInfo.market[key].num -= 1
              cartInfo = _this.cartInfo
            }
          }
        }
        _this.cartInfo.total -= 1
        _this.getTotalPrice()
        _this.$store.commit('changeCartInfo', cartInfo)
      },
      // 订单结算,判断是否登录
      settleAccount: function () {
        var _this = this
        if(_this.wxUid !== '' && _this.wxUid !== null) {
          _this.$router.push({path: 'OrderSettle'})
        } else {
          _this.$router.push({path: 'Login'})
        }
      },
      // 清空购物车
      clearCart: function () {
        var _this = this
        if(confirm('确定要清空购物车？')) {
          var cartInfo = {
            total: 0,
            amount: 0,
            market: {}
          }
          _this.$store.commit('changeCartInfo', cartInfo)
        }
      }
    },
    components: {
      BackBtn
    }
  }
</script>



// WEBPACK FOOTER //
// Cart.vue?667e60aa